import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M13.5,5.126,7.292,2.105a.717.717,0,0,0-1.031.645v7.581c0,.024.008.046.01.07L4.3,11.379l-.459-.944c-.146-.3-.4-.282-.559.04L2.156,12.726a.477.477,0,0,0,.349.715l2.466.5c.352.072.521-.115.375-.415l-.419-.861,2.6-1.288,5.36,2.52a.71.71,0,0,0,.3.068.718.718,0,0,0,.717-.717V5.771A.718.718,0,0,0,13.5,5.126ZM7.7,3.9l4.778,2.323V7.326L7.7,9.7Zm1.47,6.67,3.308-1.64v3.2Z';
const draw24px = 'M12.736,2.58a.75.75,0,0,0-1.19.608V13.9L3.977,17.889l.641-2.7a.75.75,0,0,0-1.459-.346l-1.113,4.68a.749.749,0,0,0,.556.9l4.681,1.114a.75.75,0,0,0,.347-1.459l-3.167-.754,7.891-4.162,8.438,5.948a.75.75,0,0,0,1.182-.613V9.642a.75.75,0,0,0-.311-.608Zm.31,2.076,6.759,4.885-6.759,3.565Zm7.428,14.4-6.631-4.674,6.631-3.5Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const AddYPlaneIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'addYPlane'));
AddYPlaneIcon.displayName = 'AddYPlaneIcon';
AddYPlaneIcon.propTypes = Icon.propTypes;
AddYPlaneIcon.renderIcon = props => /*#__PURE__*/React.createElement(AddYPlaneIcon, props);
export default AddYPlaneIcon;
//# sourceMappingURL=AddYPlaneIcon.js.map